








// eslint-disable-next-line @typescript-eslint/ban-ts-ignore
// @ts-ignore
import PieChart from './PieChart.js'
import Vue from 'vue'
import { ChartData, ChartOptions } from 'chart.js'

export default Vue.extend({
  components: {
    PieChart,
  },
  props: {
    data: Array,
    labels: Array,
    title: String,
  },
  data() {
    return {
      datacollection: null as null | ChartData,
      options: {
        title: {
          text: this.title,
          display: true,
        },
        maintainAspectRatio: false,
      } as ChartOptions,
    }
  },
  computed: {
    theme(): 'dark' | 'light' {
      if (this.$vuetify.theme.dark) {
        return 'dark'
      } else return 'light'
    },
  },
  mounted() {
    this.fillData()
  },
  methods: {
    fillData() {
      this.datacollection = {
        labels: this.labels,
        datasets: [
          {
            label: this.$t('this-promotion'),
            data: this.data,
            backgroundColor: [
              this.$vuetify.theme.themes[this.theme].primary,
              this.$vuetify.theme.themes[this.theme].secondary,
              this.$vuetify.theme.themes[this.theme].accent,
              this.$vuetify.theme.themes[this.theme].info,
              this.$vuetify.theme.themes[this.theme].success,
              this.$vuetify.theme.themes[this.theme].warning,
              this.$vuetify.theme.themes[this.theme].error,
            ],
          },
        ],
      } as ChartData
    },
    getRandomInt() {
      return (Math.floor(Math.random() * (500 - 50 + 10)) + 50) * 30
    },
  },
  watch: {
    data: {
      handler() {
        this.fillData()
      },
      deep: true,
    },
  },
})
